import React from 'react'
import './Main.css'
import TopMenu from './TopMenu/TopMenu'
import Home from './Home/Home'
import Team from './Team/Team'
import ReservationRecord from './ReservationRecord/ReservationRecord'
import TeamAppointment from './TeamAppointment/TeamAppointment'
import instructionsTeam from './component/instructionsTeam'
import { Layout, message } from 'antd'
import { Route, Switch,Redirect } from 'react-router-dom'

import LogoImg from '@/img/web_logo.png'
// import request from '@/utils/request'

const { Header, Sider, Content } = Layout
class Person extends React.Component {
  state = {}
  //退出登录
  logout = () => {
    // request.post('/weblogout').then(res => {
    // 	localStorage.removeItem('user')
    // 	message.success(res.msg)
    // 	this.props.history.push('/Login')
    // })
  }
  render() {
    return (
      <>
        <Layout className="warper-box">
          <Header className="header-war">
            <div className="header-war_box">
              <div className="header-war_box_left">
                <img src={LogoImg}></img>
                <div className="title">四川科技馆参观预约系统</div>
              </div>
              <div className="header-war_box_right">
                <TopMenu />
              </div>
            </div>
          </Header>
          <Layout>
            <Content className="content-style">
              <div className="content-style_conten">
                <Switch>
                  <Route path="/Main/Home" component={Home}></Route>
                  <Route path="/Main/Team" component={Team}></Route>
                  {/* <Route path="/Main/instructionsTeam" component={instructionsTeam}></Route> */}
                  <Route
                    path="/Main/ReservationRecord"
                    component={ReservationRecord}
                  ></Route>
                    <Redirect from="/Main" to="/Main/Home"></Redirect>
                </Switch>
              </div>
            </Content>
          </Layout>
        </Layout>
      </>
    )
  }
}

export default Person
